import { useCallback, useEffect, useState } from 'react';
import { Button } from 'antd';
import { PlusOutlined } from "@ant-design/icons";
import './RoamingItemsList.css';
import { getGarmentItemsView, updateRoamingItems } from 'api/roamingItems.api';
import RoamingItemsTable from '../RoamingItemsTable/RoamingItemsTable';
import AddItems from './AddItems/AddItems';
import { GarmentItem, Ipagination, RoamingItemsPayload } from 'domain/RoamingItems';
import { buildFilterStrings } from 'utils/utils';
import { notificationController } from 'controllers/notificationController';

const RoamingItemsList = () => {
  const [openForm, setOpenForm] = useState<boolean>(false)
  const [items, setItems] = useState<GarmentItem[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [pagination, setPagination] = useState<Ipagination>({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [filters, setFilters] = useState<Record<string, string | number>>({});

  const fetchGarmentItems = useCallback(async () => {
    setIsLoading(true);
    try {
      const { current, pageSize } = pagination;
      const skip = (current - 1) * pageSize;
      const filterStr = buildFilterStrings(filters);

      const data = await getGarmentItemsView({ top: pageSize, skip, filter: filterStr });
      const { value, "@odata.count": totalCount } = data;

      setPagination((prev) => ({
        ...prev,
        total: totalCount || 0,
      }));
      setItems(value || []);
    } catch (error: unknown) {
      if (error instanceof Error) {
        notificationController.error({
          message: "Something went wrong",
          description: error.message,
        });
      } else {
        notificationController.error({
          message: "Unexpected error",
          description: String(error),
        });
      }
    } finally {
      setIsLoading(false);
    }
  }, [pagination.current, pagination.pageSize, filters]);

  const handleAddItem = async (payload: RoamingItemsPayload) => {
    try {
      await updateRoamingItems(payload);
      notificationController.success({
        message: "Roaming Items updated successfully.",
      });
      fetchGarmentItems();
    } catch (error: unknown) {
      if (error instanceof Error) {
        notificationController.error({
          message: "Something went wrong",
          description: error.message,
        });
      } else {
        notificationController.error({
          message: "Unexpected error",
          description: String(error),
        });
      }
    }
  };

  useEffect(() => {
    fetchGarmentItems();
  }, [fetchGarmentItems]);

  return (
    <>
      <div className='add-item-button'>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          size={"large"}
          onClick={() => {
            setOpenForm(true)
          }}>
          Add Items
        </Button>
      </div>
      <RoamingItemsTable
        loading={isLoading}
        pagination={pagination}
        setPagination={setPagination}
        setFilters={setFilters}
        data={items}
        onAddItem={handleAddItem}
      />

      {openForm && (<AddItems isModalOpen={openForm} setIsModalOpen={setOpenForm} />)}
    </>
  );
};

export default RoamingItemsList;